import { ProficiencyLevelEnum } from '@sport-activities/sdk';

import { SportGroup } from './attendee/interfaces/sport-group.interface';
import { AudiencesEnum } from './organizer/activity-creation/components/pages/audience/enums/audiences.enum';

export const appConfig = {
  filters: {
    defaultDistance: 20,
    // our sports groups mapped to data api sport groups
    sportGroups: {
      exercise: {
        title: 'sports.exercise.title',
        description: 'sports.exercise.description',
        image: 'assets/sports/sport-filter/multisports.png',
        idCollection: [
          1, 2, 6, 27, 31, 57, 69, 89, 110, 119, 203, 204, 205, 206, 207, 208,
          209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222,
          224, 229, 243, 244,
        ],
      },
      wellness: {
        title: 'sports.wellness.title',
        description: 'sports.wellness.description',
        image: 'assets/sports/sport-filter/wellness.png',
        idCollection: [140, 178, 201],
      },
      run_walk: {
        title: 'sports.run_walk.title',
        description: 'sports.run_walk.description',
        image: 'assets/sports/sport-filter/run-and-walk.png',
        idCollection: [
          8, 21, 51, 53, 64, 65, 115, 150, 186, 232, 187, 237, 240,
        ],
      },
      cycling_skating: {
        title: 'sports.cycling_skating.title',
        description: 'sports.cycling_skating.description',
        image: 'assets/sports/sport-filter/cycling-skating.png',
        idCollection: [
          14, 16, 18, 28, 42, 72, 73, 93, 117, 127, 151, 152, 161, 187, 188,
          190, 191, 192, 193, 228, 237, 239, 240, 242,
        ],
      },
      outdoor: {
        title: 'sports.outdoor.title',
        description: 'sports.outdoor.description',
        image: 'assets/sports/sport-filter/outdoor.png',
        idCollection: [23, 25, 30, 77, 79, 126, 164, 165, 169, 170, 150, 186],
      },
      water_sports: {
        title: 'sports.water_sports.title',
        description: 'sports.water_sports.description',
        image: 'assets/sports/sport-filter/water.png',
        idCollection: [
          5, 17, 20, 26, 34, 39, 54, 55, 91, 95, 105, 120, 121, 141, 148, 166,
          176, 194, 196, 197, 198, 199, 200, 239,
        ],
      },
      sport_team: {
        title: 'sports.sport_team.title',
        description: 'sports.sport_team.description',
        image: 'assets/sports/sport-filter/teamsports.png',
        idCollection: [3, 37, 38, 82, 83, 84, 90, 92, 94, 154, 195, 226],
      },
      racket_sports: {
        title: 'sports.racket_sports.title',
        description: 'sports.racket_sports.description',
        image: 'assets/sports/sport-filter/raquets.png',
        idCollection: [10, 35, 40, 70, 123, 134, 147, 174, 180, 181],
      },
      precision: {
        title: 'sports.precision.title',
        description: 'sports.precision.description',
        image: 'assets/sports/sport-filter/precision.png',
        idCollection: [
          11, 19, 41, 43, 45, 47, 48, 81, 87, 96, 124, 137, 182, 183, 184,
        ],
      },
      combat: {
        title: 'sports.combat.title',
        description: 'sports.combat.description',
        image: 'assets/sports/sport-filter/combat.png',
        idCollection: [
          7, 12, 29, 32, 49, 50, 56, 80, 97, 98, 99, 100, 102, 103, 104, 106,
          107, 108, 159, 177,
        ],
      },
    } as { [key: string]: SportGroup },
  },
  pagination: {
    timeslot: {
      loadMore: 20,
    },
    loadMore: {
      mobile: 24,
      desktop: 24,
    },
    result: 24,
  },
  adviceContentTypeUuidCollection: [
    '7942f95d-1f93-492b-a9be-c36dab7f3878',
    '2fa5d9c4-f75d-4230-8f91-2114dd7af049',
    '0dd09f15-0515-48ce-9b51-a8ffa6bfea3e',
    '406d94ba-b437-46a0-8568-9587e87a8b10',
    '2afa13e4-a75d-422e-9f87-9fe5b6a6dee0',
    'f7f61dbe-a722-4aec-909d-645cdb572cc5',
    '38ce61df-1b03-4830-a84e-e2ea41943f2a',
    '2b731246-c0ab-4f64-a9dd-6c20ef4b07f1',
    '4252f1c8-1b52-49b5-9518-1cefcabe4a37',
    'cf81c603-256b-4a45-9c09-6eb6ec48535d',
    '8db61d7e-8a50-4e49-a3d4-f5a9ae051cf9',
    '9cace9e2-62ea-4730-b6de-508e9b595a3b',
    '3159d97f-bb80-4412-be01-cb1a9c69551c',
    'bcb329f4-6c0b-4295-8711-9644ea62704a',
    '13588a48-8acf-413e-9f9b-d3abdc195627',
    'ea2f55f1-1e81-4200-b140-3cc4fa238876',
    'df1f5db4-3798-4910-8926-f4a70a667350',
    '93d35269-7c9d-467a-96c8-7937c03e9f7e',
    '3446d4e3-4d40-43d9-ad46-ebfefc96a611',
    '3b708008-e872-4a09-af55-3880cc50b1fc',
    '89d90517-b6e6-408c-a912-3903390dfe41',
    'ea4a68c8-f70d-421c-8499-211e27ac6387',
    '2df59c68-f9d5-4a40-af76-2f7c8b1a0527',
    'a25a906d-8026-40e6-906f-231d69e0cab6',
    '42103ca7-2700-434a-83a6-d92765ba5daf',
    '8e1dda27-20da-4de6-9f4b-b687835ed82e',
    '11f63456-c61a-4b11-9cfe-878225343bee',
    'b1cbad5f-c729-4874-8719-8c5e5837fe71',
    '7e21af18-7e54-4ad0-982d-d3c2bb4ff54a',
    '7b0a650d-f417-444a-8d83-59d3aef31944',
  ],
  defaultImage: 'https://dpp1zxb4fj9eb.cloudfront.net/sports/292.jpg',
  pixl: {
    url: 'https://contents.mediadecathlon.com',
  },
  component: {
    form: {
      address: {
        searchMinimumCharacters: 3,
      },
    },
  },
  formValidationRules: {
    activityDescriptionMinimumLength: 150,
    activityTitleMaximumLength: 50,
    activityProficiencyLevels: [
      {
        labelKey: 'activity_creation.audience.level.beginner.label',
        key: 5 as ProficiencyLevelEnum,
      },
      {
        labelKey: 'activity_creation.audience.level.confirmed.label',
        key: 10 as ProficiencyLevelEnum,
      },
      {
        labelKey: 'activity_creation.audience.level.expert.label',
        key: 20 as ProficiencyLevelEnum,
      },
    ],
    activityMaxAgeInputMax: 100,
    activityMaxAgeInputMin: 0,
    activityMinAgeInputMax: 100,
    activityMinAgeInputMin: 0,
    activityAudience: [
      {
        textKey: 'activity_creation.audience.audience.adults.text',
        value: AudiencesEnum.Adults,
      },
      {
        textKey: 'activity_creation.audience.audience.children.text',
        value: AudiencesEnum.Children,
      },
      {
        textKey: 'activity_creation.audience.audience.custom.text',
        value: AudiencesEnum.Custom,
      },
    ],
    activityAddressDescriptionMaximumLength: 150,
    organizerDescriptionMinimumLength: 150,
    organizerFEDDescriptionMinimumLength: 200,
    paymentPromoCodeMinimumLength: 5,
    paymentPromoCodeMaximumLength: 12,
  },
  levValue: 1.95583,
  apiMaxLimit: 10000,
};
